import {Action} from "redux";

import {
    GetEntryNumOrderProjectListByCustomerRequest,
    GetProjectListByCustomerRequest,
    SearchProjectListByCustomerRequest,
} from "../request/project_request";

import {ICustomerProjectListActionCreator} from "../action/customer_projects_action";


interface ICustomerProjectListDispatcher {
    getEntryNumOrderProjectList(item: GetEntryNumOrderProjectListByCustomerRequest): void;

    getProjectList(item: GetProjectListByCustomerRequest): void;

    getProjectCount(): void;

    searchProjectList(searchProjectRequest: SearchProjectListByCustomerRequest): void;
}

class Dispatcher implements ICustomerProjectListDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerProjectListActionCreator) {

    }

    public getEntryNumOrderProjectList = (item: GetEntryNumOrderProjectListByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestGetEntryNumOrderProjectListAction(item));
    };

    public getProjectList = (item: GetProjectListByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestGetProjectListAction(item));
    };

    public getProjectCount = (): void => {
        this.dispatch(this.actionCreator.requestGetProjectCountAction());
    };

    public searchProjectList = (searchProjectRequest: SearchProjectListByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestSearchProjectListAction(searchProjectRequest));
    }
}

const createCustomerProjectListDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerProjectListActionCreator): ICustomerProjectListDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerProjectListDispatcher, createCustomerProjectListDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_projects_dispatcher.ts